import { getOptions } from 'highcharts';
import mensagens from './mensagens';
import { DadosPrecipitacao } from './serie-precipitacao';
import {
	DadosSerieVariavelMeteorologica,
	SerieVariavelMeteorologica,
} from './serie-variavel-meteorologica';

export class SerieEvapotranspiracao extends SerieVariavelMeteorologica {
	constructor(readonly nomeDaSerie?: string) {
		super();
	}

	obterDadosSerie(
		dados: DadosPrecipitacao,
		indexEixo: number
	): DadosSerieVariavelMeteorologica {
		return {
			serie: [
				{
					yAxis: indexEixo,
					name: this.nomeDaSerie
						? this.nomeDaSerie
						: mensagens['variavel.evapotranspiracao'],
					type: 'line',
					color: getOptions().colors?.at(0),
					data: super.prepararSerie(
						dados.datas,
						dados.precipitacao,
						dados.periodo
					),
					tooltip: {
						valueDecimals: 2,
						valueSuffix: ` ${mensagens['variavel.precipitacao.unidade']}`,
					},
				},
			],
			eixo: {
				title: {
					text: this.nomeDaSerie
						? this.adicionarUnidade(this.nomeDaSerie)
						: mensagens['variavel.precipitacao.titulo-meteograma'],
				},
				min: 0,
				softMax: 5.1,
				lineWidth: 2,
				opposite: false,
				labels: { align: 'left', x: 3 },
			},
		};
	}

	private adicionarUnidade(nomeDaSerie: string): string {
		return nomeDaSerie + ` ( ${mensagens['variavel.precipitacao.unidade']} )`;
	}
}
